import { render, staticRenderFns } from "./ConfigPositions.vue?vue&type=template&id=7c3de164&scoped=true&"
import script from "./ConfigPositions.vue?vue&type=script&lang=js&"
export * from "./ConfigPositions.vue?vue&type=script&lang=js&"
import style0 from "./ConfigPositions.vue?vue&type=style&index=0&id=7c3de164&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3de164",
  null
  
)

export default component.exports